module.exports = __webpack_public_path__ + "img/BQ.bed11784.svg";